import { render, staticRenderFns } from "./EnvelopeList.vue?vue&type=template&id=153476dc&scoped=true"
import script from "./EnvelopeList.vue?vue&type=script&lang=js"
export * from "./EnvelopeList.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeList.vue?vue&type=style&index=0&id=153476dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153476dc",
  null
  
)

export default component.exports